module.exports = __webpack_public_path__ + "img/palmar-hotel-7.6ebd5eed.jpg";